import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { GenerateTicketModalComponent } from '../../ticketing/generate-ticket-modal/generate-ticket-modal.component';
import { ApiService } from 'src/app/services/api/api.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UtilitiesService } from 'src/app/services/utilities/utilities.service';

@Component({
  selector: 'app-workflow-update',
  standalone: false,
  templateUrl: './workflow-update.component.html',
  styleUrl: './workflow-update.component.scss',
})
export class WorkflowUpdateComponent implements OnInit {
  form: FormGroup;
  approvalForm: FormGroup;
  isDarkMode!: boolean;
  data: any = null;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  approvalList: any[];

  lgaList: any;
  zoneList: any;

  workflos: any[] = [
    'ASSESSMENT',
    'LGA_IDENTIFICATION',
    'STREET_NAMING',
    'MARRIAGE_REGISTRATION',
    'DEATH_REGISTRATION',
  ];

  steges: any[] = [
    { id: 1, formattedName: 'Stage 1' },
    { id: 2, formattedName: 'Stage 2' },
    { id: 3, formattedName: 'Stage 3' },
    { id: 4, formattedName: 'Stage 4' },
    { id: 5, formattedName: 'Stage 5' },
    { id: 6, formattedName: 'Stage 6' },
  ];

  actions: any[] = [
    { id: 'NEXT', formattedName: 'Next Step' },
    { id: 'FINAL', formattedName: 'Final Step' },
  ];

  admins: any[] = [];
  lgas: any[] = [];

  rememberMe: boolean;
  isDisabled: boolean = false;
  stages: any[] = [];

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateTicketModalComponent>,
    private apiService: ApiService,
    private authService: AuthService,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
    const userDt = localStorage.getItem('USER_DATA');
    if (userDt) {
      this.data = JSON.parse(userDt);
    }

    this.initForm();
    this.initApprovalForm();
    this.getLgas();

    this.loadLgaList();
    this.subscribeToLgaChanges();
    this.subscribeToZoneChanges();
    this.getWorkflow()

  }

  getWorkflow(): void {
    this.apiService.get(`/workflow/get/single/${this.dialogData?.id}`).subscribe({
      next: (response: any) => {
        if (response) {

          this.approvalList = response.stagesDto
            .sort((a, b) => a.stageNumber - b.stageNumber)
            .map((item: any) => ({
              approver: {
                id: String(item.approverId),
                name: item.name
              },
              onApproved: item.onApproved,
              stage: {
                number: item.stageNumber,
                name: this.getStages(item.stageNumber).formattedName
              }
              
            }));

          console.log('this.approvalList', this.approvalList)

          if (this.approvalList.length > 0) {
            this.form.get('lga')?.disable();
            this.form.get('zone')?.disable();
          }

          this.patchForm(response);

        }
      },
      error: (error) => {
        this.openErrorModal(error?.message);
      },
    });
  }


  patchForm(data: any) {
    this.form.patchValue({ workflowName: data?.name });
    this.form.patchValue({ description: data?.description });
    this.form.patchValue({ lga: data?.lgaId });
    this.form.patchValue({ zone: data?.zoneId });

    this.stages = data?.stagesDto;
  }


  get lgaControl() {
    return this.form.get('lga') as FormControl;
  }

  get zoneControl() {
    return this.form.get('zone') as FormControl;
  }

  loadLgaList() {
    this.utilitiesService.getLocalGovernmentList().subscribe(
      (response) => {
        this.lgaList = response;
      },
      (error) => {
        this.openErrorModal('Error Fetching Local Government');
      }
    );
  }

  subscribeToLgaChanges() {
    this.lgaControl.valueChanges.subscribe((lga) => {
      this.zoneList = null;
      this.zoneControl.reset();
      this.getZonesFromLga(lga);
      this.getAdminUers(this.lgaControl.value);
    });
  }

  subscribeToZoneChanges() {
    this.zoneControl.valueChanges.subscribe((zone) => {
    });
  }

  getZonesFromLga(lga) {
    this.utilitiesService.getZonesFromLga(lga).subscribe((res: any) => {
      this.zoneList = res;
    });
  }

  getAdmin(id: number) {
    console.log('admins')
    return this.admins.find((admin) => admin.id === id);
  }

  getStages(id: number) {
    return this.steges.find((stage) => stage.id === id);
  }

  getAction(id: number) {
    return this.actions.find((action) => action.id === id);
  }

  initApprovalForm(): void {
    this.approvalForm = this.fb.group({
      approverId: [null, Validators.required],
      stageNumber: [null, Validators.required],
      onApproved: [null, Validators.required],
    });
  }

  handleInlineValueChange() {

    this.form.markAsDirty()

  }

  handleAdminChange(event: any) {
    console.log('event', event)
  }




  stageAlreadyConfigured(id: number) {
    return this.approvalList.some(
      (item) =>
        item.stage.number === id);
  }

  addToList(): void {
    const approvalFormValues = this.approvalForm.value;

    if (this.approvalForm.valid) {
      const newItem: any = {
        approver: {
          id: approvalFormValues.approverId,
          name: this.getAdmin(approvalFormValues.approverId)?.displayName
        },
        onApproved: approvalFormValues.onApproved,
        stage: {
          number: approvalFormValues.stageNumber,
          name: this.getStages(approvalFormValues.stageNumber)
        }
      };

      // Check if an item with the same stageNumber and onApproved already exists
      const exists = this.approvalList.some(
        (item) =>
          item.stage.number === newItem.stage.number &&
          item.onApproved === newItem.onApproved
      );

      if (!exists) {
        this.approvalList.push(newItem);
        console.log('approvalList', this.approvalList)
        this.approvalForm.reset();
        this.showErrorMessages = false;

        if (this.approvalList.length > 0) {
          this.form.get('lga')?.disable();
          this.form.get('zone')?.disable();
        }

        this.form.markAsDirty();


      } else {
        this.openErrorModal('Workflow stage already added');
      }
    } else {
      this.openErrorModal('Invalid workflow stage');
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      workflowName: [null, [Validators.required]],
      description: [null],
      lga: [null, Validators.required],
      zone: [null, Validators.required],
      workflowStages: [null],
    });
  }

  getAdminUers(lgaId: number) {
    this.isLoading = true;
    this.apiService
      .get(`/auth/lga/admins?lgaId=${lgaId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.admins = response.data.map((admin) => ({
          ...admin,
          id: String(admin.id),
          formattedName: this.toTitleCase(admin.displayName.replace(/_/g, ' ')),
        }));
      });
  }

  getLgas() {
    this.isLoading = true;
    this.apiService
      .get('/utility/all/lga')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.lgas = response.map((lga) => ({
          ...lga,
          formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
        }));
        //init defauld
        if (!this.data?.permissions.includes('GENERAL_PERMISSION')) {
          this.lgas = this.lgas
            .filter((lga) => lga?.id == this.data?.lgaId)
            .map((lga) => ({
              ...lga,
              formattedName: this.toTitleCase(lga.name.replace(/_/g, ' ')),
            }));

          this.form.patchValue({
            lga: this.lgas.length ? this.lgas[0].id : null,
          });

          this.form.get('lga')?.disable();
          this.isDisabled = true;
        }
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ reload: true });
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to update this workflow?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.updateWorkflow();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  removeFromList(index: number): void {
    this.approvalList.splice(index, 1);
    this.form.markAsDirty();
    if (this.approvalList?.length < 1) {
      this.form.get('lga')?.enable();
      this.form.get('zone')?.enable();
    }
  }

  updateWorkflow(): void {
    this.form.patchValue({
      workflowStages: this.approvalList.map((item: any) => ({
        approverId: item.approver?.id,
        stageNumber: item.stage?.number,
        onApproved: item.onApproved
      }))
    });

    this.isSubmitting = true;

    console.log(this.form.getRawValue())
    this.apiService
      .post('/workflow/update', { ...this.form.getRawValue(), id: this.dialogData?.id, })
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response.message || 'Workflow updated successfully');
        },
        (error) => {
          this.openErrorModal(error?.message || 'Error updating workflow.');
        }
      );

    this.isSubmitAttempted = true;
  }
}
